'use client';

interface OpcaoFila {
  readonly valor: string;
  readonly rotulo: string;
  readonly total: number;
}

interface FiltroFilaPrazosProps {
  readonly opcoes: readonly OpcaoFila[];
  readonly selecionada: string | null;
  readonly onSelecionar: (valor: string | null) => void;
  readonly carregando?: boolean;
}

export function FiltroFilaPrazos({
  opcoes,
  selecionada,
  onSelecionar,
  carregando = false,
}: FiltroFilaPrazosProps) {
  if (carregando) {
    return (
      <div aria-busy="true" className="flex items-center gap-2">
        <span className="text-xs text-neutral-600">Fila:</span>
        <div className="h-7 w-40 animate-pulse rounded-md bg-neutral-100" />
        <div className="h-7 w-32 animate-pulse rounded-md bg-neutral-100" />
      </div>
    );
  }

  if (opcoes.length === 0) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-xs text-neutral-600">Fila:</span>
        <span className="text-xs text-neutral-500">
          Nenhum prazo no período — nada para filtrar
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filtrar por fila">
      <span className="text-xs text-neutral-600">Fila:</span>
      {opcoes.map((opcao) => {
        const ativa = opcao.valor === selecionada;
        return (
          <button
            aria-pressed={ativa}
            className={
              ativa
                ? 'text-caption font-caption border-brand-600 bg-brand-50 text-brand-700 flex h-8 items-center gap-2 rounded-[8px] border border-solid px-3'
                : 'text-caption font-caption bg-default-background flex h-8 items-center gap-2 rounded-[8px] border border-solid border-neutral-200 px-3 text-neutral-600'
            }
            key={opcao.valor}
            onClick={() => onSelecionar(ativa ? null : opcao.valor)}
            type="button"
          >
            {opcao.rotulo}{' '}
            <span className={ativa ? 'text-brand-600' : 'text-neutral-500'}>{opcao.total}</span>
          </button>
        );
      })}
      {selecionada ? (
        <button
          className="text-xs text-neutral-600 underline"
          onClick={() => onSelecionar(null)}
          type="button"
        >
          Limpar
        </button>
      ) : null}
    </div>
  );
}
